export default __webpack_public_path__ + "static/media/attorney_info.9ba4fef0.pdf";